import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import poRequestSlice from "./slices/poRequestSlice";
// import poRequestAttachmentSlice from "./slices/poRequestAttachmentSlice"; // Removed
import itemSlice from "./slices/itemSlice";
import itemCategorySlice from "./slices/itemCategorySlice";
import itemBomSlice from "./slices/itemBomSlice";
import supplierSlice from "./slices/supplierSlice";
import quoteSlice from "./slices/quoteSlice";
import quoteItemSlice from "./slices/quoteItemSlice";
import quotePublicSlice from "./slices/quotePublicSlice";
import dashboardSlice from "./slices/dashboardSlice";
import erpSlice from "./slices/erpSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['user', 'token', 'expiresAt'],
};
const persistAuthReducer = persistReducer(authPersistConfig, authSlice);

export const store = configureStore({
  reducer: {
    auth: persistAuthReducer,
    poRequest: poRequestSlice,
    // poRequestAttachment: poRequestAttachmentSlice, // Removed
    item: itemSlice,
    itemCategory: itemCategorySlice,
    itemBom: itemBomSlice,
    supplier: supplierSlice,
    quote: quoteSlice,
    quoteItem: quoteItemSlice,
    quotePublic: quotePublicSlice,
    dashboard: dashboardSlice,
    erp: erpSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/REGISTER'],
        ignoredPaths: ['register'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export const persistor = persistStore(store);
export type AppDispatch = typeof store.dispatch;
